import { render, staticRenderFns } from "./SectionShopProfile.vue?vue&type=template&id=6137a4e8&lang=pug&"
import script from "./SectionShopProfile.vue?vue&type=script&lang=js&"
export * from "./SectionShopProfile.vue?vue&type=script&lang=js&"
import style0 from "./SectionShopProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports